import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Home from "./pages/Home";
import Signup from "./pages/Signup";
import Otp from "./pages/Otp";
import Categories from "./pages/Categories";
import Items from "./pages/Items";
import FullImage from "./pages/FullImage";
import AllProducts from "./pages/AllProducts";
import About from "./pages/About";
import Cart from "./pages/Cart";
import Search from "./pages/Search";
import Dashboard from "./pages/Dashboard";
import OrderList from "./pages/OrderList";
import DashboardJapan from "./pages/DashboardJapan";
import AddressChange from "./pages/AddressChange";
import ContactUs from "./pages/ContactUs";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Admin from "./pages/Admin";
import Poster from "./pages/Poster";
import ImageUpload from "./pages/ImageUpload";
import CategoryUpload from "./pages/CategoryUpload";
import AdminDashboard from "./pages/AdminDashboard";
import ImageCropUpload from "./components/ImageCropUpload";
import ProductDetail from "./pages/ProductDetail";
import ProductListing from "./pages/ProductListing";
import RetailSignup from "./pages/RetailSignup";
import ProfilePage from "./pages/ProfilePage";
import Address from "./pages/Address";
import OrderPlaced from "./components/OrderPlaced";
import Billing from "./pages/Billing";
import AddAddress from "./components/AddAddress";
import PrivateRoute from "./routes/PrivateRoute";
import PublicRoute from "./routes/PublicRoute";
import AccountPage from "./pages/AccountPage";
import Receipt from "./pages/Receipt";
import CusDashboard from "./pages/CusDashboard";
import Wishlist from "./pages/Wishlist";
import HomeEdit from "./pages/HomeEdit";
import VideoLinks from "./pages/VideoLinks";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/pls" element={<ProductListing />} />

                <Route path="/" element={<Home />} />
                <Route path="/home" element={<Home />} />

                <Route path="/admin" element={<Admin />} />
                <Route path="/AdminSignup" element={<Signup />} />

                {/* <Route path="/login" element={<Login />} /> */}
                <Route
                    path="/login"
                    element={
                        <PublicRoute>
                            <Login />
                        </PublicRoute>
                    }
                />
                {/* <Route path="/signup" element={<RetailSignup />} /> */}
                <Route
                    path="/signup"
                    element={
                        <PublicRoute>
                            <Signup />
                        </PublicRoute>
                    }
                />
                {/* <Route path="/signupmain" element={<Signup />} /> */}

                <Route path="/otp" element={<Otp />} />
                <Route path="/categories" element={<Categories />} />

                {/* <Route path="/fullimage/:itemId/:ID/:customerType" element={<FullImage />} /> */}
                <Route path="/fullimage/:itemId/:ID/:customerType" element={<ProductDetail />} />

                <Route path="/items" element={<Items />} />
                <Route path="/allproducts" element={<AllProducts />} />

                <Route
                    path="/cart"
                    element={
                        <PrivateRoute>
                            <Cart />
                        </PrivateRoute>
                    }
                />

                {/* <Route path="/cart" element={<Cart />} /> */}
                <Route
                    path="/wishlist"
                    element={
                        <PrivateRoute>
                            <Wishlist />
                        </PrivateRoute>
                    }
                />

                <Route path="/dashboard" element={<Dashboard />} />
                {/* <Route
                    path="/dashboard"
                    element={
                        <PrivateRoute>
                            <Dashboard />
                        </PrivateRoute>
                    }
                /> */}

                <Route path="/orderlist" element={<OrderList />} />
                {/* <Route
                    path="/orderlist"
                    element={
                        <PrivateRoute>
                            <OrderList />
                        </PrivateRoute>
                    }
                /> */}

                {/* <Route path="/dashboardjapan" element={<DashboardJapan />} /> */}
                <Route
                    path="/dashboardjapan"
                    element={
                        <PrivateRoute>
                            <DashboardJapan />
                        </PrivateRoute>
                    }
                />

                <Route path="/address" element={<AddressChange />} />

                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<ContactUs />} />
                <Route path="/termsandconditions" element={<TermsAndConditions />} />
                <Route path="/privacypolicy" element={<PrivacyPolicy />} />

                <Route path="/image" element={<ImageUpload />} />

                <Route path="/poster" element={<Poster />} />

                <Route path="/catimage" element={<CategoryUpload />} />

                <Route path="/admin-dashboard" element={<AdminDashboard />} />

                <Route path="/crop" element={<ImageCropUpload />} />

                <Route path="/pds" element={<ProductDetail />} />

                <Route path="/search" element={<ProductListing />} />

                <Route path="/profile" element={<ProfilePage />} />

                <Route path="/acc" element={<AccountPage />} />

                {/* <Route path="/search" element={<Search />} /> */}

                <Route path="/adrs" element={<Address />} />

                <Route path="/orp" element={<OrderPlaced />} />

                <Route path="/bills" element={<Billing />} />

                <Route path="/receipt" element={<Receipt />} />
                <Route path="/cusdashboard" element={<CusDashboard />} />

                <Route path="/homeedit" element={<HomeEdit />} />

                <Route path="/videolink" element={<VideoLinks />} />

                {/* <Route path="/adad" element={<AddAddress />} /> */}
                <Route
                    path="/adad"
                    element={
                        <PrivateRoute>
                            <AddAddress />
                        </PrivateRoute>
                    }
                />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
